import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import { PostHogProvider } from "posthog-js/react"
//import ReactGA from "react-ga4"

// import AuthProvider from "@src/context/auth"

import App from "./App"
import "./index.scss"
import AuthProvider from "./context/auth-user"
import UserProvider from "./context/online-user"
import PaymentProvider from "./context/payment-user"

// Initialize Google Analytics
//ReactGA.initialize("G-GCCR3444K7") // Replace with your actual GA4 Measurement ID

const postHogApiKey = process.env.REACT_APP_POSTHOG_KEY
const postHogHost = process.env.REACT_APP_POSTHOG_HOST

const AppContent = () => (
    <BrowserRouter>
        <HelmetProvider>
            <AuthProvider>
                <UserProvider>
                    <PaymentProvider>
                        <App />
                    </PaymentProvider>
                </UserProvider>
            </AuthProvider>
        </HelmetProvider>
    </BrowserRouter>
)

const root = ReactDOM.createRoot(document.getElementById("root"))

// Only initialize PostHog if API key is provided
if (postHogApiKey) {
    root.render(
        <React.StrictMode>
            <PostHogProvider
                apiKey={postHogApiKey}
                options={{
                    api_host: postHogHost,
                    defaults: '2025-05-24',
                    capture_exceptions: true,
                    debug: process.env.NODE_ENV === "development",
                }}
            >
                <AppContent />
            </PostHogProvider>
        </React.StrictMode>
    )
} else {
    // Render app without PostHog if no API key is configured
    console.warn('PostHog API key not found. PostHog analytics will not be initialized.')
    root.render(
        <React.StrictMode>
            <AppContent />
        </React.StrictMode>
    )
}